<template>
  <v-expansion-panel
    bg-color="card"
    @click="loadGames()"
  >
    <v-expansion-panel-title
      collapse-icon="chevron-up"
      expand-icon="chevron-down"
      class="title-panel-gw"
    >
      <font-awesome-icon
        :icon="['fas', gameWeekStatusIcon]"
        class="mr-2"
      />
      {{ gameWeek.title() }} - {{ gameWeek.dateRange() }}
    </v-expansion-panel-title>
    <v-expansion-panel-text>
      <game-week-action
        :game-week="gameWeek"
        @gameWeekUpdate="$emit('gameWeekUpdate', $event);"
      />
      <v-expansion-panels multiple>
        <game-panel
          v-for="clubGame in games.clubGames"
          :key="clubGame.id"
          :game="clubGame"
          @game-update="onGameUpdate($event)"
        />
        <game-panel
          v-for="nationalTeamGame in games.nationalTeamGames"
          :key="nationalTeamGame.id"
          :game="nationalTeamGame"
          @game-update="onGameUpdate($event)"
        />
      </v-expansion-panels>
    </v-expansion-panel-text>
  </v-expansion-panel>
</template>

<script>
import GameWeekAction from '@/components/Admin/GameWeekAction.vue'
import GamePanel from '@/components/Admin/GamePanel.vue'
import GameWeek from '@/models/GameWeek/gameWeek'
import Game from '@/models/Game/game'
import GameService from '@/services/game.service'

export default {
  name: 'GameWeekPanel',
  components: {
    GameWeekAction,
    GamePanel,
  },
  props: {
    gameWeek: {
      type: GameWeek,
      required: true,
    },
  },
  data() {
    return {
      games: {
        clubGames: [],
        nationalTeamGames: [],
      },
      isLoaded: false,
    };
  },
  computed: {
    gameWeekStatusIcon() {
      return this.gameWeek.isEnded() ? 'fa-lock' : 'fa-lock-open';
    },
  },
  methods: {
    loadGames() {
      if (this.isLoaded) {
        return
      }

      GameService.getGamesByGameWeek(this.gameWeek.number)
        .then((games) => {
          this.games = games
          this.isLoaded = true
        })
    },
    onGameUpdate(updatedGame) {
      const key = updatedGame.isNationalTeamGame ? 'nationalTeamGames' : 'clubGames'
      const targetList = this.games[key]
      const index = targetList.findIndex((game) => game.id === updatedGame.id)

      if (index === -1) {
        return
      }

      targetList.splice(index, 1, updatedGame)
    },
  },
}
</script>

<style scoped lang="scss">
.text-panel-gw {
  display: flex;
  justify-content: center;
}
</style>
